import {
  dateOfBirthSchema,
  dateOfBirthUI,
  ssnSchema,
  ssnUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  DEFAULT_TITLE_OPTS,
  fullNameSchema,
  fullNameUI,
  titleWithRoleUI,
} from '../../definitions';
import content from '../../locales/en/content.json';
import { validateSponsorSsn } from '../../utils/validation';

const TITLE_TEXT = content['eligibility--sponsor-info-title'];
const DESC_TEXT = content['eligibility--sponsor-info-description'];

export default {
  uiSchema: {
    ...titleWithRoleUI(TITLE_TEXT, DESC_TEXT, DEFAULT_TITLE_OPTS.sponsor),
    sponsorName: fullNameUI(),
    sponsorDob: dateOfBirthUI(),
    sponsorSsn: {
      ...ssnUI(),
      'ui:validations': [validateSponsorSsn],
    },
  },
  schema: {
    type: 'object',
    required: ['sponsorName', 'sponsorDob', 'sponsorSsn'],
    properties: {
      sponsorName: fullNameSchema,
      sponsorDob: dateOfBirthSchema,
      sponsorSsn: ssnSchema,
    },
  },
};
